/** @module csi/widget/_svg/ShapeVerticalDistribute */
define([
	"./_ShapeDistribute",
	"./PluginFactory"
], function(_ShapeDistribute,PluginFactory) {

	return PluginFactory.declare(_ShapeDistribute, {
		iconClass: "csiActionIcon svgIconVDistribute",
		pluginName: "shapeDistributeVertical",
		title: "CanvasShapeDistributeVertical",
		bHorizontal: false
	});
});
